import { sprintf } from 'sprintf-js';
import { LottoService } from './../../data/lotto.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AnimateDigitComponent } from 'src/app/component/animate-digit/animate-digit.component';

const MONTHS = [
  ' ມັງກອນ ',
  ' ກຸມພາ ',
  ' ມີນາ ',
  ' ເມສາ ',
  ' ພຶດສະພາ ',
  ' ມິຖຸນາ ',
  ' ກໍລະກົດ ',
  ' ສິງຫາ ',
  ' ກັນຍາ ',
  ' ຕຸລາ ',
  ' ພະຈິກ ',
  ' ທັນວາ '
];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild("resdigit11", { static: false }) resDigit11: AnimateDigitComponent;
  @ViewChild("resdigit12", { static: false }) resDigit12: AnimateDigitComponent;
  @ViewChild("resdigit13", { static: false }) resDigit13: AnimateDigitComponent;
  @ViewChild("resdigit14", { static: false }) resDigit14: AnimateDigitComponent;
  @ViewChild("resdigit15", { static: false }) resDigit15: AnimateDigitComponent;
  @ViewChild("resdigit16", { static: false }) resDigit16: AnimateDigitComponent;

  isSpin: boolean = false;
  lotName: string = '';
  viewDate: Date;
  matchId: number = 0;

  months = MONTHS;

  lotto1: string = '------';
  lotto6dg: string = '';
  lotto5dg: string = '';
  lotto4dg: string = '';
  lotto3dg: string = '';
  lotto2tdg: string = '';
  lotto2bdg: string = '';

  clTime1: number;
  clDTime1: Date;
  // clTime1Str:string = '00:00:00'
  waitTime: number;
  spinTime: number;

  hisSource: any[] = []; 
  constructor(private lotinfo: LottoService, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.getMatch();
    this.getResultHis();
    setInterval(() => {
      this.getMatch();
    }, 15000);
  }

  matchDate = '';
  resultTime = '';
  getMatch() {
    this.lotinfo.GetLottoCurrentMatch()
      .subscribe(data => {
        if (data.return && data.dat) {
          this.matchId = data.dat.MATCH_ID;
          this.viewDate = new Date(data.dat.M_DATE);
          this.matchDate = sprintf('%02d %s %d', this.viewDate.getDate(), MONTHS[this.viewDate.getMonth()], this.viewDate.getFullYear());
          this.lotName = data.dat.LOTTO_NAME;
          this.clDTime1 = new Date(data.dat.CLOSETIME_1);
          this.resultTime = sprintf('%02d:%02d', this.clDTime1.getHours(), this.clDTime1.getMinutes());
          this.clTime1 = this.clDTime1.getTime();
          this.spinTime = new Date(data.dat1.SPINTIME).getTime();
          this.waitTime = data.dat.WAITTIME * 1000; //convert to milli
          this.getLastResult();
        }
      });
  }

  lottodummy = '';
  getLastResult() {
    if (!this.matchId) return;
    this.lotinfo.GetLottoResult(this.matchId)
      .subscribe(data => {
        if (data.return) {
          let ct = new Date().getTime();
          this.lotto1 = data.dat.RESULT_1 ? data.dat.RESULT_1 : this.lotto1;
          if (this.resDigit11 && this.lottodummy != this.lotto1) {
            this.lottodummy = this.lotto1;
            // backend masks unreleased result as '*****' (shared with 5-digit variants) -> match any run of '*'
            if (/^\*+$/.test(this.lottodummy)) {
              this.lottodummy = '123456';
              if (this.clDTime1.getTime() < ct) {
                this.clDTime1 = new Date();
                this.clDTime1.setSeconds(this.clDTime1.getSeconds() + 45);
                this.clTime1 = this.clDTime1.getTime();
              }
            }
            this.resDigit11.SetStopTime(this.lottodummy, this.clDTime1);
            this.resDigit12.SetStopTime(this.lottodummy, this.clDTime1);
            this.resDigit13.SetStopTime(this.lottodummy, this.clDTime1);
            this.resDigit14.SetStopTime(this.lottodummy, this.clDTime1);
            this.resDigit15.SetStopTime(this.lottodummy, this.clDTime1);
            this.resDigit16.SetStopTime(this.lottodummy, this.clDTime1);
          }
          if ((this.resDigit16 && this.resDigit16.isFinished()) || ct > this.clTime1 + 120000) {
            // count from the right so sub-prizes stay correct for any result length
            this.lotto6dg = this.lotto1;
            this.lotto5dg = this.lotto1.slice(-5);
            this.lotto4dg = this.lotto1.slice(-4);
            this.lotto3dg = this.lotto1.slice(-3);
            this.lotto2tdg = this.lotto1.slice(-2);
            this.lotto2bdg = this.lotto1.substring(2, 4);  // 2-bottom = digits 3-4
          }
          else {
            this.lotto6dg = '------';
            this.lotto5dg = '-----';
            this.lotto4dg = '----';
            this.lotto3dg = '---';
            this.lotto2tdg = '--';
            this.lotto2bdg = '--';
          }          
          
          // if ((ct > this.spinTime && ct < this.clTime1))
          if ((ct > this.spinTime && ct < (this.spinTime + 30000))) {
            this.isSpin = true;
            this.lotto6dg = '------';
            this.lotto5dg = '-----';
            this.lotto4dg = '----';
            this.lotto3dg = '---';
            this.lotto2tdg = '--';
            this.lotto2bdg = '--';
          }
          else
            this.isSpin = false;

        }
      });

  }

  getResult(vwdate) {
  }

  chkTimeDiff(chkt: String): boolean {   // hh:mm:ss
    let curt = new Date();
    let arrt = chkt.split(':');
    let rest = new Date();
    rest.setHours(parseInt(arrt[0]));
    rest.setMinutes(parseInt(arrt[1]) + 1); //delay showing 1 min
    rest.setSeconds(parseInt(arrt[2]));
    return curt.getTime() > rest.getTime();
  }

  getResultHis() {
    this.lotinfo.GetLottoResultHis()
      .subscribe(data => {
        if (data.return) {
          this.hisSource = data.dat;
        }
      })
  }
}
